const filters = (state) => state.filters;

export default filters;
